import { factorySetStateAction } from '../factory'

const actions = {
  SET_STATE: 'settings/SET_STATE',
  CHANGE_SETTING: 'settings/CHANGE_SETTING',
}

export const settingsSetState = factorySetStateAction(actions.SET_STATE)
export const settingsChange = factorySetStateAction(actions.CHANGE_SETTING)

export default actions
